import { LowInformationContactDto, LowInformationContactMainAddressDto } from 'src/app/shared/interfaces';

export class LowInformationContact {
  id: number;
  nom: string;
  prenom: string;
  typeSociete: boolean;
  nePlusUtiliser: boolean;
  typeContactID: number;
  userId: number;
  userActive: boolean;
  contactParentId: number;
  contactParent: LowInformationContactDto;
  adressePrincipaleId: number;
  adressePrincipale: LowInformationContactMainAddressDto;
  verrouille: boolean;
  baseSurContact: number;

  checked: boolean;
  name: string;
  label: string;
  value: number;

  constructor(data: LowInformationContactDto) {
    Object.assign(this, data);
    this.checked = false;
    this.value = this.id;
    this.name = this.setName(this.nom, this.prenom);
    this.label = this.name;
  }

  public setName(lastName: string, firstName: string): string {
    return `${lastName || ''} ${firstName || ''}`;
  }
}
